import React from 'react';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { Calendar as CalendarIcon } from 'lucide-react';
import { Calendar } from './calendar';
import { Popover, PopoverContent, PopoverTrigger } from './popover';
import { cn } from '../../lib/utils';

export function DatePicker({ value, onChange, placeholder = 'Selecionar data', className }) {
  const date = value ? new Date(value + 'T00:00:00') : undefined;

  const handleSelect = (selected) => {
    if (selected) {
      const yyyy = selected.getFullYear();
      const mm = String(selected.getMonth() + 1).padStart(2, '0');
      const dd = String(selected.getDate()).padStart(2, '0');
      onChange(`${yyyy}-${mm}-${dd}`);
    } else {
      onChange('');
    }
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          className={cn(
            'flex items-center gap-2 w-full bg-zinc-950 border border-zinc-700 rounded-lg px-3 py-2 text-sm text-left hover:border-zinc-500 transition-colors',
            date ? 'text-white' : 'text-zinc-500',
            className
          )}
        >
          <CalendarIcon className="w-4 h-4 text-zinc-500 flex-shrink-0" />
          {date ? format(date, 'dd/MM/yyyy', { locale: ptBR }) : placeholder}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-zinc-900 border-zinc-700" align="start">
        <Calendar
          mode="single"
          selected={date}
          onSelect={handleSelect}
          locale={ptBR}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
